(() => {
  const initHeader = (scope = document) => {
    const toggle = scope.querySelector('.nav-toggle');
    const nav = scope.querySelector('.main-nav');
    if (!toggle || !nav || toggle.dataset.bound === 'true') return;

    toggle.dataset.bound = 'true';
    const closeMenu = () => {
      toggle.setAttribute('aria-expanded', 'false');
      nav.classList.remove('is-open');
    };

    toggle.addEventListener('click', () => {
      const willOpen = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(willOpen));
      nav.classList.toggle('is-open', willOpen);
    });

    nav.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeMenu();
    });
    document.addEventListener('click', (event) => {
      if (!nav.contains(event.target) && !toggle.contains(event.target)) closeMenu();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initHeader());
  } else {
    initHeader();
  }

  document.addEventListener('shopify:section:load', (event) => initHeader(event.target));
})();
